import { render, staticRenderFns } from "./deletePageModal.vue?vue&type=template&id=57ab5c94&"
import script from "./deletePageModal.vue?vue&type=script&lang=ts&"
export * from "./deletePageModal.vue?vue&type=script&lang=ts&"
import style0 from "./deletePageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports